import React from 'react';
import { Box, Button } from '@mui/material';

const ProgressButton = (props) => {
  const { loading, ...buttonProps } = props;
  return (
    <Box sx={{ display: 'contents', position: 'relative' }}>
      <Button {...buttonProps} disabled={loading}>
        {props.children}
      </Button>
    </Box>
  );
};

export default ProgressButton;
